import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=42284645&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=42284645&prod&lang=less"
import style1 from "./menu.vue?vue&type=style&index=1&id=42284645&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42284645",
  null
  
)

export default component.exports